// import _ from 'lodash'
/* eslint-disable */
const tagsView = {
  state: {
    visitedViews: [],
    cachedViews: []
  },
  mutations: {
    CHANGE_TAGVIEWS_TITLE_BY_PATH: (state,{path,title})=> {
      if (path && title) {
        let r = state.visitedViews.find(function(router){
         return router.path.indexOf(path) >= 0
        })
        if(r){
          r.title = title
        }
      }
    },
    ADD_VISITED_VIEWS: (state, view) => {
      if (state.visitedViews.some(v => v.path === view.fullPath)) return
      state.visitedViews.push({
        name: view.meta.title,
        path: view.fullPath,
        title: view.meta.title || 'no-name',
        query: view.query
      })
      const history = _.find(state.cachedViews, v => v.path === view.fullPath)
      if (history) {
        history.key++
      } else {
        state.cachedViews.push({ path: view.fullPath, key: 0 })
      }
    },
    DEL_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
      // for (const i of state.cachedViews) {
      //   if (i === view.name) {
      //     const index = state.cachedViews.indexOf(i)
      //     state.cachedViews.splice(index, 1)
      //     break
      //   }
      // }
    },
    DEL_OTHERS_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews = state.visitedViews.slice(i, i + 1)
          break;
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i);
          state.cachedViews = state.cachedViews.slice(index, i + 1);
          break;
        }
      }
    },
    DEL_ALL_VIEWS: (state) => {
      state.visitedViews = []
      state.cachedViews = []
    },
    ADD_CACHED_VIEWS: (state, path) => {
      state.cachedViews.push(path)
    },
    DEL_CACHED_VIEWS: (state, view) => {
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break;
        }
      }
    }
  },
  actions: {
    changeViewTitle({ commit }, view) {
      commit('CHANGE_TAGVIEWS_TITLE_BY_PATH', view)
    },
    addVisitedViews({ commit }, view) {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delOthersViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_OTHERS_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delAllViews({ commit, state }) {
      return new Promise((resolve) => {
        commit('DEL_ALL_VIEWS')
        resolve([...state.visitedViews])
      })
    },
    addCachedViews({ commit }, path) {
      commit('ADD_CACHED_VIEWS', path)
    },
    delCachedViews({ commit, state }, path) {
      return new Promise((resolve) => {
        commit('DEL_CACHED_VIEWS', path)
        resolve([...state.cachedViews])
      })
    }
  }
}

export default tagsView



// WEBPACK FOOTER //
// ./src/store/modules/tagsView.js